export const COOLDOWN_RATE_LIMIT_IN_SECOND: number = 60
